const secondLen = 1000
const minuteLen = 60000
const hourLen = 3600000
const dayLen = 86400000
const weekLen = 60480000
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

const nth = function (d) {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
        case 1:
            return 'st'
        case 2:
            return 'nd'
        case 3:
            return 'rd'
        default:
            return 'th'
    }
}

if (!Date.prototype.daysFromNow) {
    Date.prototype.daysFromNow = function () {
        return new Date().daysUntil(this)
    }
}

if (!Date.prototype.daysUntil) {
    Date.prototype.daysUntil = function (date, fractional) {
        if (!(date instanceof Date)) {
            throw 'Parameter for daysUntil is not a date'
        }

        if (fractional) {
            return (date.getTime() - this.getTime()) / dayLen
        }
        return Math.floor((date.getMidnight() - this.getMidnight()) / dayLen)
    }
}

if (!Date.prototype.isToday) {
    Date.prototype.isToday = function () {
        const today = new Date()
        return (
            this.getDate() == today.getDate() &&
            this.getMonth() == today.getMonth() &&
            this.getFullYear() == today.getFullYear()
        )
    }
}

if (!Date.prototype.addMilliseconds) {
    Date.prototype.addMilliseconds = function (millis) {
        return new Date(this.getTime() + millis)
    }
}

if (!Date.prototype.addSeconds) {
    Date.prototype.addSeconds = function (seconds) {
        return this.addMilliseconds(seconds * secondLen)
    }
}

if (!Date.prototype.addMinutes) {
    Date.prototype.addMinutes = function (minutes) {
        return this.addMilliseconds(minutes * minuteLen)
    }
}

if (!Date.prototype.addHours) {
    Date.prototype.addHours = function (hours) {
        return this.addMilliseconds(hours * hourLen)
    }
}

if (!Date.prototype.addDays) {
    Date.prototype.addDays = function (days) {
        return this.addMilliseconds(days * dayLen)
    }
}

if (!Date.prototype.addWeeks) {
    Date.prototype.addWeeks = function (weeks) {
        return this.addMilliseconds(weeks * weekLen)
    }
}

if (!Date.prototype.addMonths) {
    Date.prototype.addMonths = function (months) {
        var originMonth = this.getMonth()
        var newD = new Date(this)
        newD.setMonth(originMonth + months)

        // correct the days
        if (newD.getMonth() - originMonth < months) {
            newD = newD.addDays(5)
        }
        if (newD.getMonth() - originMonth > months) {
            newD = newD.addDays(0 - newD.getDate())
        }
        return newD
    }
}

if (!Date.prototype.addYears) {
    Date.prototype.addYears = function (years) {
        var newD = new Date(this)
        newD.setFullYear(this.getFullYear() + years)
        return newD
    }
}

if (!Date.prototype.getFirstDayOfMonth) {
    Date.prototype.getFirstDayOfMonth = function () {
        return new Date(this.getFullYear(), this.getMonth(), 1)
    }
}

if (!Date.prototype.getLastDayOfMonth) {
    Date.prototype.getLastDayOfMonth = function () {
        return new Date(this.getFullYear(), this.getMonth() + 1, 0)
    }
}

if (!Date.prototype.getEndOfDay) {
    Date.prototype.getEndOfDay = function () {
        var end = new Date(this)
        end.setHours(23)
        end.setMinutes(59)
        end.setSeconds(59)
        end.setMilliseconds(999)
        return end
    }
}

if (!Date.prototype.getStartOfDay) {
    Date.prototype.getStartOfDay = function () {
        return this.getMidnight()
    }
}

if (!Date.prototype.getMidnight) {
    Date.prototype.getMidnight = function () {
        var midnight = new Date(this)
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0)
        midnight.setMilliseconds(0)
        return midnight
    }
}

if (!Date.prototype.between) {
    Date.prototype.between = function (date1, date2) {
        if (typeof date1.getTime !== 'function' && typeof date2.getTime !== 'function') {
            throw 'Arguments must be date objects'
        }
        var thisTime = this.getTime()
        if (date1 && date2) {
            var d1Time = date1.getTime()
            var d2Time = date2.getTime()

            var max = Math.max(d1Time, d2Time)
            var min = Math.min(d1Time, d2Time)

            return thisTime <= max && thisTime >= min
        } else if (date1) {
            return thisTime >= date1.getTime()
        } else if (date2) {
            return thisTime <= date2.getTime()
        }
        return true
    }
}

if (!Date.prototype.toHyphenatedDateString) {
    Date.prototype.toHyphenatedDateString = function () {
        return this.toLocaleDateString().replaceAll('/', '-')
    }
}

if (!Date.prototype.toISODateString) {
    Date.prototype.toISODateString = function () {
        var year = this.getFullYear()
        var month = this.getMonth() + 1 // 0 indexed
        var day = this.getDate()
        return `${year}-${month}-${day}`
    }
}

if (!Date.prototype.isValid) {
    Date.prototype.isValid = function () {
        return !isNaN(this)
    }
}

if (!Date.prototype.humanize) {
    Date.prototype.humanize = function () {
        if (this.isToday()) {
            return 'today'
        }

        var unitCount = this.daysFromNow()

        if (unitCount == 1) {
            return 'tomorrow'
        }
        if (unitCount == -1) {
            return 'yesterday'
        }

        var suffix = 'away'
        if (unitCount < -1) {
            suffix = 'ago'
        }

        unitCount = Math.abs(unitCount)

        var unit = 'days'
        if (unitCount > 364) {
            unitCount = unitCount / 365
            unit = unitCount == 1 ? 'year' : 'years'
        } else if (unitCount > 29) {
            unitCount = unitCount / 30
            unit = unitCount == 1 ? 'month' : 'months'
        }

        return `${unitCount.round()} ${unit} ${suffix}`
    }
}

if (!Date.prototype.getMonthName) {
    Date.prototype.getMonthName = function () {
        return monthNames[this.getMonth()]
    }
}

if (!Date.prototype.getDayOfMonth) {
    Date.prototype.getDayOfMonth = function () {
        var day = this.getDate()
        return day + nth(day)
    }
}

if (!Date.prototype.equals) {
    Date.prototype.equals = function (rightVal) {
        return this.getTime() === (rightVal && rightVal.getTime())
    }
}
